import type { ClientMeta } from "./types";

interface HeaderProps {
  meta: ClientMeta | null;
  error: string | null;
}

export function Header({ meta, error }: HeaderProps) {
  const subParts: string[] = [];
  if (meta) {
    if (meta.mission.site) subParts.push(meta.mission.site);
    const local =
      meta.mission.captured_local ??
      (meta.mission.captured_at
        ? new Date(meta.mission.captured_at).toLocaleString()
        : null);
    if (local) subParts.push(local);
    if (meta.mission.client) subParts.push(meta.mission.client);
  }
  const sub = subParts.join(" · ");

  return (
    <header
      className="bg-navy-deep px-12 py-7 relative shrink-0 overflow-hidden"
      style={{ minHeight: "108px" }}
    >
      {/* Copper ring motif — load-bearing brand cue. Kept subtle so the
       * header reads as PFD without crowding the mission name. */}
      <div
        className="absolute -top-20 -right-20 w-[400px] h-[400px] rounded-full pointer-events-none"
        style={{ border: "1px solid rgba(196,122,42,0.10)" }}
        aria-hidden
      />
      <div
        className="absolute -top-32 -right-32 w-[560px] h-[560px] rounded-full pointer-events-none"
        style={{ border: "1px solid rgba(196,122,42,0.05)" }}
        aria-hidden
      />

      <div className="relative flex items-center gap-3 mb-3">
        <div
          className="w-8 h-8 rounded-md flex items-center justify-center"
          style={{ background: "var(--color-copper)" }}
          aria-hidden
        >
          <div
            className="w-3 h-3 rounded-full"
            style={{ border: "2px solid var(--color-navy-deep)" }}
          />
        </div>
        <div className="text-xs font-semibold text-white tracking-[0.10em] uppercase">
          Precision Flight Data
        </div>
      </div>

      <div className="relative flex items-baseline gap-4 flex-wrap">
        {meta ? (
          <>
            <h1
              className="text-white"
              style={{
                fontFamily: "var(--font-display)",
                fontSize: "30px",
                fontWeight: 400,
                lineHeight: 1.2,
                letterSpacing: "-0.005em",
              }}
            >
              {meta.mission.display_name}
            </h1>
            {sub && (
              <p style={{ color: "var(--color-silver)", fontSize: "13px" }}>
                {sub}
              </p>
            )}
          </>
        ) : error ? (
          <p style={{ color: "var(--color-copper-light)", fontSize: "14px" }}>
            Failed to load mission: {error}
          </p>
        ) : (
          <p style={{ color: "var(--color-silver)", fontSize: "14px" }}>
            Loading mission…
          </p>
        )}
      </div>
    </header>
  );
}
